<!-- =========================================================================================
  File Name: BookEditTabInformation.vue
  Description: Book Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" disabled label="코스" v-model="book_data.courseName" v-validate="'required'" name="courseName" />
        <span class="text-danger text-sm" v-show="errors.has('courseName')">{{ errors.first('courseName') }}</span>

        <vs-input class="w-full mt-4" disabled label="레벨" v-model="book_data.levelName" v-validate="'required'" name="levelName" />
        <span class="text-danger text-sm" v-show="errors.has('levelName')">{{ errors.first('levelName') }}</span>

        <vs-input class="w-full mt-4" label="교재명" v-model="book_data.bookName" name="bookName" />
        <span class="text-danger text-sm" v-show="errors.has('bookName')">{{ errors.first('bookName') }}</span>

        <vs-input class="w-full mt-4" disabled label="권" v-model="book_data.volumeNumber" name="volumeNumber" />
        <span class="text-danger text-sm" v-show="errors.has('volumeNumber')">{{ errors.first('volumeNumber') }}</span>

        <vs-input class="w-full mt-4" disabled label="교재코드" v-model="book_data.bookCode" name="bookCode" />
        <span class="text-danger text-sm" v-show="errors.has('bookCode')">{{ errors.first('bookCode') }}</span>

        <vs-input class="w-full mt-4" label="판매가" v-model="book_data.price" name="price" />
        <span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>

        <vs-input class="w-full mt-4" label="비고" v-model="book_data.remark" name="remark" />
        <span class="text-danger text-sm" v-show="errors.has('remark')">{{ errors.first('remark') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">  
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">수정</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'

import { fetchData, putData } from '@/api/module'

export default {
  components: {
    vSelect,
    Datepicker
    // flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return { 
      languages: lang,
      book_data: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    confirmSaveChanges () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '교재 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {
      if (!this.validateForm) return

      try {
        const { data } = await putData('book', this.book_data)
        console.log(data)
        const bookSeq = this.book_data.bookSeq
        this.$router.push(`/book/book-view/${bookSeq}`)
        this.showSaveChangesSuccess()

      } catch (error) {
        // console.log(error.response.data.msg);
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '교재 정보 수정',
        text: '저장 되었습니다.'
      })
    },
    reset_data () {
      this.book_data = JSON.parse(JSON.stringify(this.data))
    }
  },
  async created () {
    try {
      const keyword = ''
      const institutes  = await fetchData('institute/search', keyword)
      // console.log(institutes.data);
      this.instituteOptions = institutes.data.list
    } catch (error) {
      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  }
}
</script>
